(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-photo-reviews"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('rc-photo-reviews')) {
    customElements.define('rc-photo-reviews', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const track = this.querySelector('[data-review-track]');
        const cards = [...track.querySelectorAll('article')];
        const previous = this.querySelector('[data-review-prev]');
        const next = this.querySelector('[data-review-next]');
        const gallery = this.querySelector('[data-review-gallery]');
        const photos = [...track.querySelectorAll('[data-review-open]')];
        const dialog = this.querySelector('dialog');
        const large = dialog.querySelector('[data-review-large]');
        const details = dialog.querySelector('[data-review-viewer-details]');
        const galleryPrevious = dialog.querySelector('[data-gallery-prev]');
        const galleryNext = dialog.querySelector('[data-gallery-next]');
        this.dialog = dialog;
        let current = 0;
        const update = () => {
          previous.disabled = track.scrollLeft < 2;
          next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        };
        const scroll = direction => {
          const card = cards.find(card => !card.hidden);
          const gap = parseFloat(getComputedStyle(track).gap) || 0;
          track.scrollBy({ left: direction * ((card?.offsetWidth || track.clientWidth) + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        const showPhoto = index => {
          if (!photos.length) return;
          current = (index + photos.length) % photos.length;
          const button = photos[current];
          large.src = button.dataset.reviewFull;
          large.alt = button.querySelector('img').alt;
          details.replaceChildren(button.closest('article').querySelector('[data-review-details]').content.cloneNode(true));
          dialog.querySelector('[data-gallery-counter]').textContent = (current + 1) + ' / ' + photos.length;
          galleryPrevious.disabled = galleryNext.disabled = photos.length < 2;
        };
        const openPhoto = (index, opener) => {
          if (!photos.length) return;
          this.opener = opener;
          showPhoto(index);
          this.oldOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          dialog.showModal();
        };
        previous.addEventListener('click', () => scroll(-1), { signal });
        next.addEventListener('click', () => scroll(1), { signal });
        track.addEventListener('scroll', update, { passive: true, signal });
        track.addEventListener('keydown', event => {
          if (event.target !== track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            scroll(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, { signal });
        this.addEventListener('click', event => {
          const thumbnail = event.target.closest('[data-review-thumb]');
          if (thumbnail) { openPhoto(Number(thumbnail.dataset.reviewThumb), thumbnail); return; }
          const button = event.target.closest('[data-review-open]');
          if (button) openPhoto(photos.indexOf(button), button);
        }, { signal });
        gallery.addEventListener('click', () => openPhoto(0, gallery), { signal });
        galleryPrevious.addEventListener('click', () => showPhoto(current - 1), { signal });
        galleryNext.addEventListener('click', () => showPhoto(current + 1), { signal });
        dialog.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            showPhoto(current + (event.key === 'ArrowRight' ? 1 : -1));
          }
        }, { signal });
        const swipe = dialog.querySelector('[data-review-swipe]');
        let touch = null;
        swipe.addEventListener('touchstart', event => {
          touch = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
        }, { passive: true, signal });
        swipe.addEventListener('touchend', event => {
          if (!touch || !event.changedTouches.length) return;
          const dx = event.changedTouches[0].clientX - touch.x;
          const dy = event.changedTouches[0].clientY - touch.y;
          touch = null;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) showPhoto(current + (dx < 0 ? 1 : -1));
        }, { passive: true, signal });
        swipe.addEventListener('touchcancel', () => touch = null, { passive: true, signal });
        this.querySelector('[data-review-close]').addEventListener('click', () => dialog.close(), { signal });
        dialog.addEventListener('close', () => {
          document.documentElement.style.overflow = this.oldOverflow ?? '';
          this.opener?.focus({ preventScroll: true });
        }, { signal });
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const box = dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
        }, { signal });
        document.addEventListener('shopify:block:select', event => {
          if (!this.contains(event.target)) return;
          event.target.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'instant' });
        }, { signal });
        this.observer = new ResizeObserver(update);
        this.observer.observe(track);
        update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        if (this.dialog?.open) document.documentElement.style.overflow = this.oldOverflow ?? '';
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ruido-collection-intro"] && !Shopify.designMode) return;
  try {
    
  import('@shopify/events').then(({ CartLinesUpdateEvent }) => {
  if (!customElements.get('ruido-collection-offer')) {
    customElements.define('ruido-collection-offer', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        document.addEventListener(CartLinesUpdateEvent.eventName, async (event) => {
          try {
            const result = await event.promise;
            if (result?.cart) this.refreshCount();
          } catch {}
        }, { signal: this.controller.signal });
        window.addEventListener('pageshow', (event) => {
          if (event.persisted) this.refreshCount();
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
      async refreshCount() {
        try {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } });
          if (response.ok) {
              const cart = await response.json();
              const count = cart.items.reduce((sum, item) => {
                const title = (item.product_title || item.title || '').toLowerCase();
                const kind = title.includes('hoodie') ? 'hoodie' : /t[ -]?shirt/.test(title) ? 'shirt' : title.includes('cd') ? 'cd' : '';
                return sum + (kind === this.dataset.promoKind ? item.quantity : 0);
              }, 0);
              this.updateCount(count);
            }
        } catch {}
      }
      updateCount(quantity) {
        if (!Number.isFinite(quantity)) return;
        const target = Number(this.dataset.promoTarget);
        const count = Math.min(Math.max(quantity, 0), target);
        this.querySelectorAll('.rco__slot').forEach((slot, index) => slot.classList.toggle('is-filled', index < count));
        const progress = this.querySelector('.rco__progress');
        if (!progress) return;
        progress.setAttribute('aria-valuenow', String(count));
        progress.firstElementChild.style.width = (count * 100 / target) + '%';
        this.querySelector('.rco__status').textContent = this.dataset.promoLabel + ' · ' + count + '/' + target;
      }
    });
  }
  });

  } catch(e) { console.error(e); }
})();
})();
